import { render, staticRenderFns } from "./DisputeCreatedChatMessage.htm?vue&type=template&id=61f3fd5a&scoped=true&"
import script from "./DisputeCreatedChatMessage.ts?vue&type=script&lang=js&"
export * from "./DisputeCreatedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./DisputeCreatedChatMessage.scss?vue&type=style&index=0&id=61f3fd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3fd5a",
  null
  
)

export default component.exports